import { useCallback, useMemo } from 'react';
import { WorkerQueryFilters } from '../../models/worker';
import { applyValidWorkerLifecycleFilters, validateWorkerLifecycleFilters } from './workerLifecycleFilterValidation';
import { summarizeWorkerLifecycleFilters, useSyncedWorkerLifecycleFilters } from './workerLifecycleFilterValue';

export function useWorkerLifecycleFilterControls(initialFilters: WorkerQueryFilters) {
    const [value, setValue] = useSyncedWorkerLifecycleFilters(initialFilters);
    const valid = useMemo(
        () => Object.keys(validateWorkerLifecycleFilters(value)).length === 0,
        [value],
    );
    const activeCount = useMemo(
        () => Object.values(value).filter((item) => item !== undefined && item !== '').length,
        [value],
    );
    const summary = useMemo(() => summarizeWorkerLifecycleFilters(value), [value]);
    const apply = useCallback(
        (callback: () => void) => applyValidWorkerLifecycleFilters(value, callback),
        [value],
    );
    const clear = useCallback(() => setValue({}), [setValue]);

    return { value, setValue, valid, activeCount, summary, apply, clear };
}
